'use client';
import { useRef } from 'react';
import {
  I_MOBILE_PC_COMMON_OVL,
  I_MOBILE_PC_COMMON_OVL_SENSITIVE,
} from '~/utils/i-mobile-constants';
import { css } from '@styled-system/css';
import { Box, Center } from '@styled-system/jsx';
import { useInitAd } from './use-init-ad';

type Props = {
  canShowGoogleAd: boolean;
};

export const PCOverlayAd = ({ canShowGoogleAd }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const unit = canShowGoogleAd
    ? I_MOBILE_PC_COMMON_OVL
    : I_MOBILE_PC_COMMON_OVL_SENSITIVE;

  useInitAd(unit);

  return (
    <Box
      ref={containerRef}
      position="fixed"
      bottom={{
        base: 'calc(env(safe-area-inset-bottom) + 54px)',
        lg: '0',
      }}
      left={0}
      right={0}
      width="100%"
      background="rgba(0, 0, 0, 0)"
      zIndex="overlayAdsContainer"
      textAlign="center"
      transform="translate3d(0, 0, 0)"
    >
      <button
        type="button"
        onClick={() => {
          if (containerRef.current) {
            containerRef.current.style.display = 'none';
          }
        }}
        className={CloseButtonStyle}
      />
      <Center
        id={unit.elementid}
        margin="auto"
        textAlign="center"
        zIndex="overlayAds"
      ></Center>
    </Box>
  );
};

const CloseButtonStyle = css({
  fontFamily: 'Arial',
  width: '14px',
  height: '14px',
  margin: '0',
  padding: '0',
  position: 'absolute',
  top: '-25px',
  left: '5px',
  cursor: 'pointer',
  background: 'rgba(0, 0, 0, 0)',
  border: 'none',

  '&::after, &::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '2px',
    height: '14px',
    background: '#000',
  },

  '&::before': {
    transform: 'translate(-50%, -50%) rotate(45deg)',
  },

  '&::after': {
    transform: 'translate(-50%, -50%) rotate(-45deg)',
  },
});
